/**
 * The QuickCasa Universe colour palette - the brand colours cranked to eleven.
 * All values are hex strings so they can feed both THREE.Color and CSS.
 */
export const palette = {
  primaryGlow: '#6C63FF',
  secondaryGlow: '#00D4FF',
  warmAccent: '#FF6B6B',
  solarCore: '#FFE07A',
  solarFlare: '#FF8A3D',
  deepSpaceNear: '#0A0A1A',
  deepSpaceFar: '#1A0A2E',
  nebulaPurple: '#7A3CFF',
  nebulaTeal: '#1FC8C8',
  nebulaMagenta: '#FF4DD2',
  nebulaGold: '#FFC65C',
  textPrimary: '#FFFFFF',
  textMuted: '#B9B4E8',
} as const

/**
 * The four nebula tints sampled by the background shader to paint the deep-space
 * clouds. Kept as a flat list so the shader receives a predictable uniform array.
 */
export const nebulaColours: readonly string[] = [
  palette.nebulaPurple,
  palette.nebulaTeal,
  palette.nebulaMagenta,
  palette.nebulaGold,
]
